import { CMS_Content_Module_Text } from './types';
import { Icon } from '@cue/atoms';
import { Mdx } from '@cue/utility';
import { useLivestreamStatus } from '@project/hooks/use-livestream-status';
import React from 'react';

type TextContentModuleProps = CMS_Content_Module_Text['data'];

export const TextContentModule: React.FC<TextContentModuleProps> = (props) => {
  const { mdx, css_class } = props;
  const { isLive } = useLivestreamStatus();
  //
  const has_livestream = mdx?.includes('{live}') && isLive;
  return (
    <div className={css_class}>
      {has_livestream ? <Icon name="live" /> : ''}
      <Mdx css_class={`${has_livestream ? 'has-live' : ''}`}>
        {mdx?.replace('{live}', '') as string}
      </Mdx>
    </div>
  );
};
